import { render, staticRenderFns } from "./storeList.vue?vue&type=template&id=3f10b094&scoped=true"
import script from "./storeList.vue?vue&type=script&lang=js"
export * from "./storeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f10b094",
  null
  
)

export default component.exports